/**
 * Recharge Bundles — live apps.liquid behavior + kit-builder accordion step collapse
 */
(function () {
  if (window.__yycRechargeBundleInit) return;
  window.__yycRechargeBundleInit = true;

  const config = window.__yycRechargeBundleConfig || {};
  let sectionsToHide = [];
  let variantsToPrefix = [];
  let fixedChooseCount = 0;
  let statusElement = null;
  let statusElementHasScrolled = false;
  let reviewOrderElementHasScrolled = false;
  let extrasElementHasScrolled = false;
  let bundleInitialized = false;

  const getBundleRoot = () => document.querySelector('#recharge-bundles');

  const extractNumberFromString = (input) => {
    const match = String(input).match(/\d+/);
    return match ? match[0] : null;
  };

  const getStorefrontToken = () => config.storefrontAccessToken || '';

  const filteredCollectionDetails = (data) => {
    const result = {};
    if (!data?.data?.nodes) return result;

    data.data.nodes.forEach((node) => {
      if (node?.metafield?.key === 'kit_preselections') {
        const collectionId = extractNumberFromString(node.id);
        result[collectionId] = JSON.parse(node.metafield.value);
        sectionsToHide.push(collectionId);
      }
    });
    return result;
  };

  const filterProductVariantDetails = (data) => {
    const result = {};
    if (!data?.data?.nodes) return result;

    data.data.nodes.forEach((node) => {
      const productVariantField = node.fields?.find((f) => f.key === 'product_variant');
      const preselectionQuantityField = node.fields?.find((f) => f.key === 'preselection_quantity');
      if (productVariantField && preselectionQuantityField) {
        result[extractNumberFromString(productVariantField.value)] = true;
      }
    });
    return result;
  };

  const fetchProductVariantsFromMetaobjects = async (metaobjectIds) => {
    const prefixedMetaobjectIds = Object.values(metaobjectIds).flat();
    if (!prefixedMetaobjectIds.length || !getStorefrontToken()) return {};

    const query = `{ nodes(ids: ["${prefixedMetaobjectIds.join('", "')}"]) { ... on Metaobject { fields { key value } } } } }`;
    const response = await fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Shopify-Storefront-Access-Token': getStorefrontToken(),
      },
      body: JSON.stringify({ query }),
    });
    if (!response.ok) return {};
    return filterProductVariantDetails(await response.json());
  };

  const fetchCollectionsWithMetaobjectKey = async (collectionIds) => {
    if (!getStorefrontToken() || !collectionIds.length) return {};
    const prefixedCollectionIDs = collectionIds.map((id) => `gid://shopify/Collection/${id}`);
    const query = `{ nodes(ids: ["${prefixedCollectionIDs.join('", "')}"]) { ... on Collection { id metafield(namespace: "custom", key: "kit_preselections") { value } } } } }`;
    const response = await fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Shopify-Storefront-Access-Token': getStorefrontToken(),
      },
      body: JSON.stringify({ query }),
    });
    if (!response.ok) return {};
    return fetchProductVariantsFromMetaobjects(filteredCollectionDetails(await response.json()));
  };

  const handleFixedQuantity = (elements) => {
    elements.forEach((element) => {
      element.querySelectorAll('.rb-btn-qty-plus').forEach((button) => {
        button.click();
        fixedChooseCount++;
      });
    });
  };

  const handleExtrasSelection = (extrasElement) => {
    extrasElement.querySelectorAll('.rb-addon-item').forEach((element) => {
      const plusButton = element.querySelector('.rb-btn-qty-plus');
      const input = element.querySelector('input');
      if (input) input.setAttribute('readonly', true);
      new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class' && plusButton) {
            plusButton.disabled = element.classList.contains('rb-addon-item--added');
          }
        });
      }).observe(element, { attributes: true, attributeFilter: ['class'] });
    });
  };

  const initializeCollectionMutationObserver = (parent) => {
    const observer = new MutationObserver(async (mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'childList' &&
          mutation.addedNodes.length &&
          mutation.addedNodes[0].nodeType === Node.ELEMENT_NODE &&
          mutation.addedNodes[0].querySelector?.('.rb-section')
        ) {
          statusElement = parent.querySelector('.status-bar-sign-up');
          if (statusElement && !statusElementHasScrolled) {
            statusElement.style.visibility = 'hidden';
            window.scrollTo(0, 0);
            statusElementHasScrolled = true;
          }

          const rechargeCollectionElements = parent.querySelectorAll('.rb-section');
          const collectionIds = {};
          Array.from(rechargeCollectionElements).forEach((collection) => {
            collectionIds[collection.id] = collection;
          });

          if (Object.keys(collectionIds).length && rechargeCollectionElements.length) {
            await fetchCollectionsWithMetaobjectKey(Object.keys(collectionIds));
            sectionsToHide.forEach((id) => {
              const collectionSection = collectionIds[id];
              if (collectionSection) collectionSection.style.setProperty('display', 'none', 'important');
            });

            const productVariantElements = variantsToPrefix
              .map((id) => parent.querySelector(`[data-rb-item-id='${id}']`))
              .filter(Boolean);
            handleFixedQuantity(productVariantElements);
          }
        }

        const reviewOrderElement = parent.querySelector('.rb-review-order');
        if (reviewOrderElement && !reviewOrderElementHasScrolled) {
          window.scrollTo(0, 0);
          reviewOrderElementHasScrolled = true;
        }

        const extrasElement = parent.querySelector('.rb-extras');
        if (extrasElement && !extrasElementHasScrolled) {
          window.scrollTo(0, 0);
          extrasElementHasScrolled = true;
        }
      }
    });
    observer.observe(parent, { childList: true, subtree: true });
  };

  const updateChooseCountElement = (element, count) => {
    const textNodes = Array.from(element.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE);
    if (textNodes[0]) textNodes[0].textContent = textNodes[0].textContent.replace(/\d+/, count);
  };

  const updateSelectedCountElement = (offsetProgressCount) => {
    const selectedCountElement = document.querySelector('#recharge-bundles .status-bar-sign-up .rb-bg .selected__count__element');
    if (!selectedCountElement) return;
    const textNodes = Array.from(selectedCountElement.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE);
    if (textNodes[0]) textNodes[0].textContent = textNodes[0].textContent.replace(/\d+/, offsetProgressCount);
  };

  const BUNDLE_ACCENT = '#fffa6a';

  const styleProgressBar = (bar) => {
    if (!bar) return;
    bar.style.backgroundColor = BUNDLE_ACCENT;
  };

  const updateCustomProgressBar = (totalItems, offsetProgressCount) => {
    const existingProgressBar = document.querySelector('#recharge-bundles .progress__bar');
    if (existingProgressBar) {
      existingProgressBar.style.width = `${(offsetProgressCount / totalItems) * 100}%`;
      styleProgressBar(existingProgressBar);
    }
  };

  const buildCustomProgressBar = (total) => {
    const parent = document.querySelector('#recharge-bundles .status-bar-sign-up .rb-bg');
    if (!parent || document.querySelector('#recharge-bundles .progress__bar')) return;

    const newProgressBarContainer = document.createElement('div');
    const newProgressBar = document.createElement('div');
    newProgressBarContainer.classList.add('progress__bar__container');
    newProgressBar.classList.add('progress__bar');
    styleProgressBar(newProgressBar);
    newProgressBarContainer.appendChild(newProgressBar);
    parent.insertBefore(newProgressBarContainer, parent.firstChild);
    updateCustomProgressBar(total, 0);
  };

  const initializeProgressBarMutationObserver = (parent) => {
    let initialChooseCount = 0;
    let initialSelectedCount = 0;

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        const chooseElement = mutation.target.querySelector?.('.status-bar-sign-up .tlh-title');
        const selectedElement = mutation.target.querySelector?.('.status-bar-sign-up .thl-copy');
        const existingChooseCountElement = document.querySelector('#recharge-bundles .status-bar-sign-up .rb-bg .choose__count__element');
        const existingSelectedCountElement = document.querySelector('#recharge-bundles .status-bar-sign-up .rb-bg .selected__count__element');

        if (!chooseElement || !selectedElement) return;

        initialChooseCount = parseInt(chooseElement.textContent.trim().match(/\d+/)[0], 10);
        initialSelectedCount = parseInt(selectedElement.textContent.trim().match(/\d+/)[0], 10);

        if (!existingChooseCountElement) {
          const newChooseCountElement = chooseElement.cloneNode(true);
          chooseElement.style.display = 'none';
          newChooseCountElement.classList.add('choose__count__element');
          chooseElement.parentNode.insertBefore(newChooseCountElement, chooseElement.nextSibling);
          updateChooseCountElement(newChooseCountElement, initialChooseCount - fixedChooseCount);
        }

        if (!existingSelectedCountElement) {
          const newSelectedCountElement = selectedElement.cloneNode(true);
          selectedElement.style.display = 'none';
          newSelectedCountElement.classList.add('selected__count__element');
          selectedElement.parentNode.insertBefore(newSelectedCountElement, selectedElement.nextSibling);
          updateSelectedCountElement(0);
          if (statusElement) statusElement.style.visibility = 'visible';
        }

        new MutationObserver((innerMutations) => {
          innerMutations.forEach((innerMutation) => {
            if (innerMutation.type === 'characterData') {
              const offsetProgressCount = parseInt(innerMutation.target.data.trim().match(/\d+/)[0], 10) - initialSelectedCount;
              updateSelectedCountElement(offsetProgressCount);
              updateCustomProgressBar(initialChooseCount - initialSelectedCount, offsetProgressCount);
            }
          });
        }).observe(selectedElement, { characterData: true, subtree: true });

        buildCustomProgressBar(initialChooseCount - initialSelectedCount);
        observer.disconnect();
      });
    });

    observer.observe(parent, { childList: true, subtree: true });
  };

  const initializeExtrasMutationObserver = (parent) => {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        const extrasElement = mutation.target.querySelector?.('.rb-extras .rb-items-wrapper');
        if (extrasElement) {
          handleExtrasSelection(extrasElement);
          observer.disconnect();
        }
      });
    });
    observer.observe(parent, { childList: true, subtree: true });
  };

  const getVisibleSections = (root) =>
    Array.from(root.querySelectorAll('.rb-section')).filter((section) => {
      if (sectionsToHide.includes(section.id)) return false;
      return section.offsetParent !== null && !section.style.display?.includes('none');
    });

  const getSectionProgress = (section) => {
    let selected = 0;
    section.querySelectorAll('[data-rb-item-id]').forEach((item) => {
      const input = item.querySelector('input');
      const val = input ? parseInt(input.value || '0', 10) : 0;
      if (val > 0) selected += val;
      else if (item.classList.contains('rb-item--added')) selected += 1;
    });

    const headerText = section.textContent || '';
    let max = 0;
    const slash = headerText.match(/(\d+)\s*\/\s*(\d+)/);
    const choose = headerText.match(/choose\s+(\d+)/i);
    if (slash) max = parseInt(slash[2], 10);
    else if (choose) max = parseInt(choose[1], 10);
    else max = Math.max(selected, 1);

    if (section.querySelector('.rb-step-index--complete')) selected = max;
    return { selected: Math.min(selected, max), max };
  };

  const isSectionComplete = (section) => {
    const { selected, max } = getSectionProgress(section);
    return selected >= max && max > 0;
  };

  const buildCircles = (selected, max) => {
    const wrap = document.createElement('div');
    wrap.className = 'kbs__circles';
    for (let i = 1; i <= max; i++) {
      const circle = document.createElement('div');
      circle.className = 'kbs__circle' + (selected >= i ? ' kbs__circle--active' : '');
      wrap.appendChild(circle);
    }
    return wrap;
  };

  const initializeStepCollapse = (root) => {
    const strings = config.strings || {};
    const chevronUrl = config.chevronUrl || '';
    const checkUrl = config.checkUrl || '';
    const state = { sections: [], wired: false };

    const collapseAllExcept = (index) => {
      state.sections.forEach((entry, i) => {
        entry.expanded = i === index;
        entry.body.style.display = i === index ? '' : 'none';
        entry.caret.classList.toggle('kbs__caret--inactive', i !== index);
      });
    };

    const advanceFrom = (completedIndex) => {
      const nextIndex = state.sections.findIndex((entry, i) => i > completedIndex && !isSectionComplete(entry.section));
      if (nextIndex !== -1) collapseAllExcept(nextIndex);
      else collapseAllExcept(-1);
    };

    const refreshSectionUI = (entry) => {
      const { selected, max } = getSectionProgress(entry.section);
      entry.circles.replaceWith(buildCircles(selected, max));
      entry.circles = entry.progress.querySelector('.kbs__circles');

      const completed = selected >= max;
      entry.circles.style.display = completed ? 'none' : '';
      entry.completedLabel.style.display = completed ? '' : 'none';
      entry.chooseLabel.style.display = completed ? 'none' : '';
      entry.chooseCount.textContent = String(max - selected);

      if (completed && !entry.section.dataset.yycWasComplete) {
        entry.section.dataset.yycWasComplete = 'true';
        entry.expanded = false;
        entry.body.style.display = 'none';
        entry.caret.classList.add('kbs__caret--inactive');
        advanceFrom(entry.index);
      } else if (!completed) {
        delete entry.section.dataset.yycWasComplete;
      }
    };

    const wireSection = (section, index) => {
      if (section.dataset.yycKbsWired) return;
      section.dataset.yycKbsWired = 'true';
      section.classList.add('yyc-kbs-section');

      const header = section.querySelector('.rb-section-header') || section.querySelector('.rb-step-header');
      const body = section.querySelector('.rb-items-wrapper') || section.querySelector('.rb-step-main') || section;
      if (!header || !body) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kbs__header yyc-kbs-header';
      btn.innerHTML = header.innerHTML;

      const titleEl = btn.querySelector('.rb-section-title, .rb-step-title, h3, h4, p');
      const titleText = titleEl ? titleEl.textContent.trim() : `Step ${index + 1}`;

      btn.innerHTML = '';
      const left = document.createElement('div');
      left.className = 'kbs__header-main';
      const titleP = document.createElement('p');
      titleP.className = 'kbs__header-title';
      titleP.textContent = titleText;
      left.appendChild(titleP);

      const progress = document.createElement('div');
      progress.className = 'kbs__selection-progress';
      const { selected, max } = getSectionProgress(section);
      const circles = buildCircles(selected, max);
      progress.appendChild(circles);

      const completed = selected >= max;
      const completedLabel = document.createElement('p');
      completedLabel.className = 'kbs__status-label';
      completedLabel.style.display = completed ? '' : 'none';
      completedLabel.innerHTML = `${strings.completed || 'Completed'} <img src="${checkUrl}" alt="" width="12" height="10">`;
      circles.style.display = completed ? 'none' : '';

      const chooseLabel = document.createElement('p');
      chooseLabel.className = 'kbs__status-label';
      chooseLabel.style.display = completed ? 'none' : '';
      const chooseCount = document.createElement('span');
      chooseCount.textContent = String(max - selected);
      chooseLabel.append(`${strings.choose || 'Choose'} `, chooseCount);

      progress.appendChild(completedLabel);
      progress.appendChild(chooseLabel);
      left.appendChild(progress);
      btn.appendChild(left);

      const caretWrap = document.createElement('div');
      caretWrap.className = 'kbs__header-caret';
      const caret = document.createElement('img');
      caret.src = chevronUrl;
      caret.alt = '';
      caret.width = 24;
      caret.height = 24;
      caret.className = index === 0 ? '' : 'kbs__caret--inactive';
      caretWrap.appendChild(caret);
      btn.appendChild(caretWrap);

      header.style.display = 'none';
      section.insertBefore(btn, body);

      const entry = {
        section,
        index,
        btn,
        body,
        caret,
        progress,
        circles: progress.querySelector('.kbs__circles'),
        completedLabel,
        chooseLabel,
        chooseCount,
        expanded: index === 0,
      };

      body.style.display = index === 0 ? '' : 'none';

      btn.addEventListener('click', () => {
        entry.expanded = !entry.expanded;
        body.style.display = entry.expanded ? '' : 'none';
        caret.classList.toggle('kbs__caret--inactive', !entry.expanded);
      });

      section.addEventListener('click', () => window.setTimeout(() => refreshSectionUI(entry), 50));
      section.addEventListener('change', () => window.setTimeout(() => refreshSectionUI(entry), 50));

      state.sections.push(entry);
    };

    const setup = () => {
      getVisibleSections(root).forEach((section, index) => wireSection(section, index));
      if (state.sections.length && !state.sections.some((e) => e.expanded)) {
        collapseAllExcept(0);
      }
    };

    setup();
    new MutationObserver(() => setup()).observe(root, { childList: true, subtree: true });
  };

  const init = () => {
    const parent = getBundleRoot();
    if (!parent || bundleInitialized) return;
    bundleInitialized = true;

    initializeCollectionMutationObserver(parent);
    initializeProgressBarMutationObserver(parent);
    initializeExtrasMutationObserver(parent);
    initializeStepCollapse(parent);
  };

  const waitForBundleRoot = (attempts = 0) => {
    if (getBundleRoot()) {
      init();
      return;
    }
    if (attempts < 40) window.setTimeout(() => waitForBundleRoot(attempts + 1), 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForBundleRoot());
  } else {
    waitForBundleRoot();
  }

  document.addEventListener('shopify:section:load', () => waitForBundleRoot());
})();
